import { NavSection } from '@components/v2/layout/AppTemplate/appTemplate.types';
import { useAdminSubNav } from '../subNavs/admin.subNav';
import { useSettingsSubNav } from '../subNavs/settings.subNav';
import { SubNavContext, useSubNavContext } from './useSubNavContext';

export const useSubNavItems = (pathname: string): NavSection[] => {
  const settingsItems = useSettingsSubNav();
  const adminItems = useAdminSubNav();
  const subNavContext = useSubNavContext(pathname);

  const itemsBySubNavContext: Record<SubNavContext, NavSection[]> = {
    settings: settingsItems,
    admin: adminItems,
  };

  return subNavContext ? itemsBySubNavContext[subNavContext] : [];
};
